import React, { memo }  from 'react';
import classNames from 'classnames';
import { unitConversion } from "@/pages/dashboard/utils/utils";
import { ColorProgressProps } from '../_config/interface';
import { DEFAULT_PROGRESS_PROPS } from '../_config/constant';

function ColourTransformation(props: ColorProgressProps) {

  const {
    className,
    style,
    colours,
    values,
    isUnit,
    direction,
  } = props;

  return (
    <div
      className={classNames({
        'db-map-chart-color-progress': true,
        'transform-vertical': direction === 'vertical',
        [className as string]: !!className,
      })}
      style={style}
    >
      {/* <span className="label-info">{labelText}</span> */}
      <div className="color-box">
        {direction === 'vertical' || (
          <div className="color-value-box">
            {values?.length && values?.map((t: string | number) => (
              <span key={t} className="color-value-item">
                <label className="num">{t}</label>
              </span>
            ))}
          </div>
        )}
        <div className="color-lump-box">
          {colours?.length && colours?.map((t: string) => (<label key={t} className="color-lump-item" style={{ backgroundColor: `${t}` }}></label>))}
        </div>
        {direction === 'vertical' && (
          <div className="color-value-box">
            {values?.length && values?.map((t: string | number) => (
              <span key={t} className="color-value-item">
                <label className="num">{isUnit && t !== 0 ? '$' : ''}{unitConversion(t, true,false)}</label>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

ColourTransformation.defaultProps = DEFAULT_PROGRESS_PROPS;

export default memo(ColourTransformation);
